import axios from 'axios';
import config from '../common/config';

export default {
  getRideInformation( token, rideInformationId ) {
    return axios.get(`${config.config.ROOT_URL}/ride_information_api/${rideInformationId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  updateRideInformation( token, rideInformationId, rideInformationInfo, force = false ){
    const formData = new FormData()
    formData.append('data', JSON.stringify( rideInformationInfo ) );
    const url = force 
      ? `${config.config.ROOT_URL}/update_ride_information_api/${rideInformationId}/force`
      : `${config.config.ROOT_URL}/update_ride_information_api/${rideInformationId}`;
    
    return axios.post(url, formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'content-type': 'multipart/form-data',
        'X-GUI-Version': process.env.VUE_APP_GUI_VERSION
      }
    });
  },
  setRideInformation( token, rideInformationInfo){
    const formData = new FormData()
    formData.append('data', JSON.stringify( rideInformationInfo ) );
    return axios.post(`${config.config.ROOT_URL}/add_ride_api`,formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'content-type': 'multipart/form-data'        }
    });
  },
  getBillingData( token ) {
    return axios.get(`${config.config.ROOT_URL}/ride_manager_billing_api`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  getOneTimeAccessUsageByManager( token, startDate = null, endDate = null ) {
    if (startDate || endDate) {
      const formData = new FormData()
      formData.append('data', JSON.stringify({ start_date: startDate, end_date: endDate }));

      return axios.post(`${config.config.ROOT_URL}/one_time_access_usage_by_manager`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'content-type': 'multipart/form-data'
        }
      });
    } else {
      return axios.get(`${config.config.ROOT_URL}/one_time_access_usage_by_manager`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
    }
  },
  lockRide( token, rideId, isLocked ) {
    const formData = new FormData()
    formData.append('data', JSON.stringify({ is_locked: isLocked }));
    
    return axios.post(`${config.config.ROOT_URL}/lock_ride_api/${rideId}`, formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'content-type': 'multipart/form-data'
      }
    });
  },
  getPdfExportInfo( token, rideManagerId = null ) {
    const url = rideManagerId 
      ? `${config.config.ROOT_URL}/pdf_export_info_api/${rideManagerId}`
      : `${config.config.ROOT_URL}/pdf_export_info_api`;
    
    return axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
};
